import React, { useState, useEffect } from 'react';
import './LotFilter.css'; // Import the CSS file for component styling
import CentralCalls from '../../centralCalls';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const LotFilter = ({ onLotChange }) => {
    const [builders, setBuilders] = useState([]);
    const [selectedBuilder, setSelectedBuilder] = useState('');
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [selectedNeighborhood, setSelectedNeighborhood] = useState('');
    const [lots, setLots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedLot, setSelectedLot] = useState('');
    const [recentLots, setRecentLots] = useState([]);
    const [showRecentLots, setShowRecentLots] = useState(false);
    const [allLots, setAllLots] = useState([]);
    const [filteredLots, setFilteredLots] = useState([]);
    const [addressInput, setAddressInput] = useState('');
    const [showAddressDropdown, setShowAddressDropdown] = useState(false);
    const [showAllLots, setShowAllLots] = useState(false);
    const [openLots, setOpenLots] = useState([]);

    const location = useLocation();
    const useQuery = () => {
        return new URLSearchParams(location.search);
    };
    const query = useQuery();
    //const [lotOidFromUrl, setLotOidFromUrl] = useState(query.get('lot_oid'));
    // Inside your LotFilter component
    const toggleShowRecentLots = (show) => {
        setShowRecentLots(show);
    };

    // Function to parse query parameters



    const lotOidFromUrl = query.get('lot_oid');
    useEffect(() => {
       // console.log('fecting...')
        fetchRecentLots();
        fetchAllLots();
        fetchOpenLots();
    }, []);

    const fetchRecentLots = async () => {
        try {
            const response = await CentralCalls.callStoredProcedureNoParams('sp_getRecentLots');
           
            setRecentLots(response);
        } catch (error) {
            console.error('Failed to fetch recent lots:', error);
        }
    };
    const fetchAllLots = async () => {
        try {
            const rows = await CentralCalls.fetchTableDataNoWhere('lot');
            setAllLots(rows);
        } catch (error) {
            console.error('Failed to fetch all lots:', error);
        }
    };

    const fetchOpenLots = async () => {
        try {
            const response = await CentralCalls.callStoredProcedureWithParams('sp_get_openLotsList', {});
           
            setOpenLots(response);
            if (!showAllLots) {
                const uniqueBuilders = [...new Map(response.map(item => [item.builder_oid, { oid: item.builder_oid, name: item.builder_name }])).values()];
                setBuilders(uniqueBuilders);
                setNeighborhoods([]);
                setLots([]);
                setSelectedBuilder('');
                setSelectedNeighborhood('');
                setSelectedLot('');
            }
        } catch (error) {
            console.error('Failed to fetch open lots:', error);
        }
    };

    const updateFiltersFromOpenLots = () => {
        const uniqueBuilders = [...new Map(openLots.map(item => [item.builder_oid, { oid: item.builder_oid, name: item.builder_name }])).values()];
        setBuilders(uniqueBuilders);
        setNeighborhoods([]);
        setLots([]);
        setSelectedBuilder('');
        setSelectedNeighborhood('');
        setSelectedLot('');
    };

    // Fetch builders from API
    useEffect(() => {
        if (!lotOidFromUrl) {
            loadBuilders();
        }
    }, []);
    const loadLotFromUrl = async (id) => {
        try {
          
            const rows = await CentralCalls.fetchTableData('vw_lot_info', { 'lot_oid': id });
           
            if (rows && rows.length > 0) {
                setLoading(true);
                const { builder_oid, neighborhood_oid } = rows[0];
                await setSelectedLot(id);
                setAddressInput(allLots.find(l => l.oid === id)?.address || '');
                onLotChange(id);
                await loadBuilders();
                setSelectedBuilder(builder_oid);
                await loadNeighborhoods(builder_oid);
                setSelectedNeighborhood(neighborhood_oid);
                await loadLots(neighborhood_oid);
                setLoading(false);
            }

        } catch (error) {
            console.error('Failed to fetch initial data:', error);
        }
    }
    useEffect(() => {
        const fetchInitialData = async () => {
            if (lotOidFromUrl) {
                loadLotFromUrl(lotOidFromUrl);
            }
            setLoading(false);
        };
        // Fetch initial lot, builder, and neighborhood info based on the lot_oid URL parameter
        fetchInitialData();
    }, [lotOidFromUrl]);

    const loadBuilders = async () => {
        const rows = await CentralCalls.fetchTableDataNoWhere('builder');
        setBuilders(rows);
    };

    const handleShowAllLotsChange = (e) => {
        const checked = e.target.checked;
        setShowAllLots(checked);
        if (checked) {
            loadBuilders();
            setSelectedBuilder('');
            setSelectedNeighborhood('');
            setSelectedLot('');
        } else {
            updateFiltersFromOpenLots();
        }
    };
    const handleBuilderChange = async (event) => {
        const selectedBuilder = event.target.value;
        setSelectedBuilder(selectedBuilder);
        setSelectedNeighborhood('');
        setSelectedLot('');
        if (showAllLots) {
            loadNeighborhoods(selectedBuilder);
        } else {
            const filtered = openLots.filter(o => o.builder_oid === Number(selectedBuilder));
            const uniqueNeighborhoods = [...new Map(filtered.map(item => [item.neighborhood_oid, { oid: item.neighborhood_oid, name: item.neighborhood_name }])).values()];
            setNeighborhoods(uniqueNeighborhoods);
        }
    };
    const loadNeighborhoods = async (builder) => {
        const rows = await CentralCalls.fetchTableData('neighborhood', { 'builder_oid': builder });
        setNeighborhoods(rows);
    }
    const loadLots = async (neighborhood) => {
        const rows = await CentralCalls.fetchTableData('lot', { 'neighborhood_oid': neighborhood, 'deleted': 0 });
        setLots(rows);
    }
    const handleNeighborhoodChange = async (event) => {
        const selectedNeighborhood = event.target.value;
        setSelectedNeighborhood(selectedNeighborhood);
        setSelectedLot('');
        if (showAllLots) {
            loadLots(selectedNeighborhood);
        } else {
            const filtered = openLots.filter(o => o.neighborhood_oid === Number(selectedNeighborhood));
            const uniqueLots = [...new Map(filtered.map(item => [item.lot_oid, { oid: item.lot_oid, lot_num: item.lot_num }])).values()];
            setLots(uniqueLots);
        }
    };
    const handleLotChange = async (event) => {
        const selectedLot = event.target.value;
        setSelectedLot(selectedLot);
        setAddressInput(lots.find(l => l.oid === selectedLot)?.address || '');
        //CentralCalls.upsertData({ oid : selectedLot }, 'phase', 'update')
        // Send selectedLot OID to parent component
        // Replace the following line with your desired code
        onLotChange(selectedLot);
        const phases = await CentralCalls.fetchTableData('phase', { lot_oid: selectedLot });
        saveRecentSelection(event.target.value);
    };
    const saveRecentSelection = async (lot_oid) => {
        try {
            const phases = await CentralCalls.fetchTableData('phase', { lot_oid: lot_oid }); // Fetch data asynchronously
            await Promise.all(
                phases.map(phase =>
                    CentralCalls.upsertData({date_updated: CentralCalls.sqlFormatdatetime(), oid: phase.oid }, 'phase', 'update')
                )
            );
        } catch (error) {
            console.error('An error occurred:', error); // Handle any errors that occur during the fetch or update process
        }
    }
    const handleRecentLotSelect = (id) => {
       
        loadLotFromUrl(id);
        setShowRecentLots(false);
        saveRecentSelection(id);
    };
    const handleAddressInputChange = (event) => {
        const value = event.target.value;
        setAddressInput(value);
        if (value.trim() === '') {
            setFilteredLots([]);
            setShowAddressDropdown(false);
        } else {
            const sourceLots = showAllLots ? allLots : allLots.filter(lot => openLots.some(o => o.lot_oid === lot.oid));
            const filtered = sourceLots.filter(lot => lot.address && lot.address.toLowerCase().includes(value.toLowerCase()));
            setFilteredLots(filtered);
            setShowAddressDropdown(true);
        }
    };

    const handleAddressSelect = (lot) => {
        setAddressInput(lot.address);
        setShowAddressDropdown(false);
        loadLotFromUrl(lot.oid);
    };
    return (
        <div className="lot-filter-container">
            {loading ? (
                <CircularProgress />
            ) : (
                <>
                    <div className="lot-filter" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                        <div style={{ display: 'flex', width: '100%', gap: '12px', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div
                                    onMouseEnter={() => toggleShowRecentLots(true)}
                                    onMouseLeave={() => toggleShowRecentLots(false)}
                                >
                                    <Tooltip placement="top" title="Recent">
                                        <IconButton className="recent-lots-button" color="primary" aria-label="save" size="medium">
                                            <FontAwesomeIcon icon={faEye} />
                                        </IconButton>
                                    </Tooltip>
                                    {showRecentLots && (
                                        <div className="recent-lots-list" onMouseEnter={() => toggleShowRecentLots(true)}
                                            onMouseLeave={() => toggleShowRecentLots(false)}>
                                            <ul>
                                                {recentLots.map((lot) => (
                                                    <li key={lot.id} onClick={() => handleRecentLotSelect(lot.id)}>
                                                        {lot.name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                <select className="select-list" value={selectedBuilder} onChange={handleBuilderChange} style={{ width: '100%' }}>
                                    <option value="">Select Builder</option>
                                    {builders && builders.sort((a, b) => a.name.localeCompare(b.name)).map((builder) => (
                                        <option key={builder.oid} value={builder.oid}>
                                            {builder.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ width: '28px', textAlign: 'center', color: '#666' }}>{'>>'}</div>

                            <div style={{ flex: 1 }}>
                                <select className="select-list" value={selectedNeighborhood} onChange={handleNeighborhoodChange} style={{ width: '100%' }}>
                                    <option value="">Select Neighborhood</option>
                                    {neighborhoods && neighborhoods.sort((a, b) => a.name.localeCompare(b.name)).map((neighborhood) => (
                                        <option key={neighborhood.oid} value={neighborhood.oid}>
                                            {neighborhood.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ width: '28px', textAlign: 'center', color: '#666' }}>{'>>'}</div>

                            <div style={{ flex: 1 }}>
                                <select className="select-list" value={selectedLot} onChange={handleLotChange} style={{ width: '100%' }}>
                                    <option value="">Select Lot</option>
                                    {lots && lots.sort((a, b) => a.lot_num.localeCompare(b.lot_num)).map((lot) => (
                                        <option key={lot.oid} value={lot.oid}>
                                            {lot.lot_num}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                                <input
                                    type="checkbox"
                                    id="allLots"
                                    checked={showAllLots}
                                    onChange={handleShowAllLotsChange}
                                    style={{ marginRight: '8px', transform: 'scale(1.05)' }}
                                />
                                <label htmlFor="allLots" style={{ fontSize: '0.95rem', fontWeight: 500, margin: 0 }}>All Lots</label>
                            </div>

                            <div className="address-search-container" style={{ position: 'relative', marginLeft: '12px' }}>
                                <Tooltip title={addressInput}>
                                    <input
                                        type="text"
                                        placeholder="Search Address"
                                        value={addressInput}
                                        onChange={handleAddressInputChange}
                                        className="select-list"
                                        style={{ width: '280px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                    />
                                </Tooltip>
                                {showAddressDropdown && filteredLots.length > 0 && (
                                    <div className="address-dropdown" style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        zIndex: 1000
                                    }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {filteredLots.map((lot) => (
                                                <li
                                                    key={lot.oid}
                                                    onClick={() => handleAddressSelect(lot)}
                                                    style={{ padding: '8px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                                >
                                                    {lot.address}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>


                </>

            )}
        </div>
    );
}
export default LotFilter;